import { log } from '@/lib/logger'
import { useState, useEffect } from 'react';
import { getConversationsAuthToken, CONVERSATIONS_API_TOKEN } from '@/config/env';

export function useAuth() {
    // Initialize with the token immediately to avoid null on first render
    const [token, setToken] = useState<string | null>(() => {
        // Get token immediately during initialization
        const authToken = getConversationsAuthToken();
        log.debug('useAuth: Initial token retrieval', {
            hasToken: !!authToken,
            tokenLength: authToken?.length || 0,
            tokenPreview: authToken ? `${authToken.substring(0, 20)}...` : 'NO TOKEN',
            hasEnvToken: !!CONVERSATIONS_API_TOKEN,
            envTokenPreview: CONVERSATIONS_API_TOKEN ? `${CONVERSATIONS_API_TOKEN.substring(0, 20)}...` : 'NO ENV TOKEN'
        });
        return authToken || null;
    });

    useEffect(() => {
        // Update token in case localStorage changes
        const authToken = getConversationsAuthToken();
        log.debug('useAuth: Token update in useEffect', {
            hasToken: !!authToken,
            tokenLength: authToken?.length || 0,
            tokenPreview: authToken ? `${authToken.substring(0, 20)}...` : 'NO TOKEN'
        });
        setToken(authToken || null);
    }, []);

    return { token };
}
